import Breadcrumb from '#client/components/common/Breadcrumb/Breadcrumb';

export default function PurchaseOrderBreadcrumbs(props) {
    let breadcrumbItems = generateBreadcrumbs(props);

    return <Breadcrumb items={breadcrumbItems} />;
}

const generateBreadcrumbs = (props) => {
    const breadcrumbs = [];

    if (props.nsId) {
        breadcrumbs.push({ label: 'Purchase Orders', url: '/purchase-orders' });
        breadcrumbs.push({ label: props.nsId, url: `${props.isPoLevel !== true ? `/purchase-orders/${props.poId}` : ''}` });
    }

    if (props.nsId && props.asnId && props.asnIdValue) {
        const asnBreadcrumb = { label: props.asnIdValue };

        if (props.navigateFromASN === true) {
            asnBreadcrumb.url = `/purchase-orders/${props.poId}/advanced-shipping-notice/${props.asnId}`;
        }

        breadcrumbs.push(asnBreadcrumb);
    }

    if (props.nsId && props.name) {
        breadcrumbs.push({ label: `${props.name}` });
    }

    return breadcrumbs;
};
